import React, { Component } from 'react'
import axios from 'axios'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import Auth from '../../Modules/Auth'
import MeetingItem from '../../Components/Meeting/MeetingItem'
import './MeetingListPage.scss'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import ReactGA from 'react-ga'
import MetaTags from 'react-meta-tags'

class MeetingListPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            list: [],
            totalCount: 0,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadList(0)
    }

    loadList = (offset) => {
        const { cookies } = this.props
        const limit = 100

        axios
            .get(`${BACKEND_HOST}/postings/?project_id=${cookies.get('project')}&offset=${offset}&limit=${limit}&type=MEETING`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ list: res.data.data, totalCount: res.data.total })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderList = () => {
        const List = this.state.list.map((item) => {
            return <MeetingItem item={item} key={item._id} />
        })
        return List
    }

    render() {
            return (
                <div>
                    <MetaTags>
                        <title>투명한 집짓기 하우스플래너 - 회의 및 미팅 기록</title>
                    </MetaTags>
                    <HeaderMenu />
                    <div className="section_wrap section_wrap_menu">
                        <div className="meeting_list_wrap common_list">
                            <div className="common_wrap">
                                {this.props.cookies.get('demo') !== 'true' && (
                                        <Link to={'/meeting/write'}>
                                            <div className="write_btn pc_v">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14"
                                                    height="14"
                                                    viewBox="0 0 14 14">
                                                    <g fill="none" fillRule="evenodd">
                                                        <path
                                                            stroke="#FFF"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="1.3"
                                                            d="M10.743 1.007l1.03 1.031a1 1 0 0 1 0 1.414l-6.829 6.843H2.5V7.85l6.828-6.843a1 1 0 0 1 1.415 0z"
                                                        />
                                                        <path stroke="#FFF" strokeLinecap="square" d="M8.5 2.5l2 2" />
                                                        <rect
                                                            width="13"
                                                            height="1.2"
                                                            x=".5"
                                                            y="12.759"
                                                            fill="#FFF"
                                                            fillRule="nonzero"
                                                            rx=".6"
                                                        />
                                                    </g>
                                                </svg>
                                                작성하기
                                            </div>
                                            <div className="full_btn_m mobile_v">작성하기</div>
                                        </Link>
                                    )}
                                <h1>회의록</h1>
                                <h2>
                                    논의 할 내용을 남겨주세요. <br />
                                    상세한 기록은 원활한 공사 진행에 큰 도움이 됩니다. 
                                </h2>
                                <div className="list_title pc_v">
                                    <p className="title">제목</p>
                                    <p className="name">작성자</p>
                                    <p className="date">작성일</p>
                                </div>
                                <div className="list_wrap">
                                    {this.state.list.length !== 0 ? (
                                        this.renderList()
                                    ) : (
                                        <div className="no_list_wrap">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="55"
                                                height="63"
                                                viewBox="0 0 55 63">
                                                <defs>
                                                    <linearGradient id="c1" x1="50%" x2="0%" y1="50%" y2="100%">
                                                        <stop offset="0%" stopColor="#E1E4EA" />
                                                        <stop offset="100%" stopColor="#D6D7DB" />
                                                    </linearGradient>
                                                    <path id="b1" d="M31 0v23h23z" />
                                                    <filter
                                                        id="a1"
                                                        width="113%"
                                                        height="113%"
                                                        x="-6.5%"
                                                        y="-6.5%"
                                                        filterUnits="objectBoundingBox">
                                                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                                        <feGaussianBlur
                                                            in="shadowOffsetOuter1"
                                                            result="shadowBlurOuter1"
                                                            stdDeviation=".5"
                                                        />
                                                        <feColorMatrix
                                                            in="shadowBlurOuter1"
                                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                                        />
                                                    </filter>
                                                </defs>
                                                <g fill="none" fillRule="evenodd">
                                                    <path
                                                        fill="#E2E4E9"
                                                        d="M3 1h27.952L54 23.997V60a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3z"
                                                    />
                                                    <g
                                                        stroke="#F5F7FA"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2.4">
                                                        <path d="M37 32.733L17.733 52M17.733 32.733L37 52" />
                                                    </g>
                                                    <g transform="translate(0 1)">
                                                        <use fill="#000" filter="url(#a1)" xlinkHref="#b1" />
                                                        <use fill="url(#c1)" xlinkHref="#b1" />
                                                    </g>
                                                </g>
                                            </svg>
                                            <p>아직 등록된 내용이 없습니다.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
    }
}

export default withCookies(MeetingListPage)



// WEBPACK FOOTER //
// ./Src/Containers/Meeting/MeetingListPage.js